import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from './styled-icon'

export const CsUserIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M896 896s0-52.8-4.4-80.4c-3.6-21.8-33.8-50.6-162.2-97.8C603 671.4 610.8 694 610.8 608.6c0-55.4 28.2-23.2 46.2-128.4 7-41.4 12.6-13.8 27.8-80.2 8-34.8-5.4-37.4-3.8-54s3.2-31.4 6.2-65.4c3.6-42-35.4-152.6-175.2-152.6S333.2 238.6 337 280.8c3 33.8 4.6 48.8 6.2 65.4s-11.8 19.2-3.8 54c15.2 66.2 20.8 38.6 27.8 80.2 18 105.2 46.2 73 46.2 128.4 0 85.6 7.8 63-118.6 109.2-128.4 47-158.8 76-162.2 97.8C128 843.2 128 896 128 896h768z" />
    </g>
  </StyledIcon>
)

CsUserIcon.displayName = 'CsUserIcon'
